import React, { useEffect } from 'react';
import { ThemeProvider } from '@mui/material';
import { Dashboard } from './pages/Dashboard';
import { theme } from './theme';
import { useOwnersStore } from './store/ownersStore';
import { useDealStagesStore } from './store/dealStagesStore';
import { useFormOptionsStore } from './store/formOptionsStore';
import { AuthenticationProvider } from './auth/AuthenticationProvider';
import { useAuth } from 'react-oidc-context';

function AppContent() {
  const initializeOwner = useOwnersStore(state => state.initializeOwner);
  const fetchDealStages = useDealStagesStore(state => state.fetchDealStages);
  const fetchOptions = useFormOptionsStore(state => state.fetchOptions);
  const auth = useAuth();

  useEffect(() => {
    // Only initialize data when authenticated
    if (auth.isAuthenticated) {
      initializeOwner();
      fetchDealStages(auth.user?.access_token || '');
      fetchOptions(auth.user?.access_token || '');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isAuthenticated]);

  return <Dashboard />;
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <AuthenticationProvider>
        <AppContent />
      </AuthenticationProvider>
    </ThemeProvider>
  );
}

export default App;
